// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Common Pages
import Header from './Components/Header';
import HeroSection from './Components/Herosection';
import Services from './Components/Services';
import Award from './Components/Award';
import CardSwiper from './Components/Cardswipper';
import Project from './Components/Project';
import FAQ from './Components/FAQ';
import Parallax from './Components/Parallax';
import Blog from './Components/Blog';
import Footer from './Components/Footer';
import Aboutpr from './Components/Aboutpr';
import ServiceSection from './Components/ServiceSection';
import Servicehero from './Components/Servicehero';
import Bloghero from './Components/Bloghero';
import ContactPage from './Components/Contactpage';
import Contacthero from './Components/Contacthero';


// Example placeholder components for new pages
function Home() {
  return (
    <>
      <Header />
      <HeroSection />
      <Services />
      <Award />
      <CardSwiper />
      <Project />
      <FAQ />
      <Footer />
    </>
  );
}

function Abouts() {
  return (
    <>
      <Header />
      <Aboutpr />
      <Footer />
    </>
  );
}

function ServicePage() {
  return (
    <>
      <Header />
      <ServiceSection />
      <Servicehero />
      <Footer />
    </>
  );
}

function BlogPage() {
  return (
    <>
      <Header />
      <Blog />
      <Bloghero />
      <Footer />
    </>
  );
}

function ContactPg() {
  return (
    <>
      <Header />
      <ContactPage />
      <Contacthero />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Abouts />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/contactpg" element={<ContactPg />} />
      </Routes>
    </Router>
  );
}

export default App;
